import { render, staticRenderFns } from "./PremiumFreepassCard.vue?vue&type=template&id=e21efe58&scoped=true"
import script from "./PremiumFreepassCard.vue?vue&type=script&lang=js"
export * from "./PremiumFreepassCard.vue?vue&type=script&lang=js"
import style0 from "./PremiumFreepassCard.vue?vue&type=style&index=0&id=e21efe58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21efe58",
  null
  
)

export default component.exports